module.exports = __webpack_public_path__ + "img/screen-logo.bcc76fa9.png";